import React, { Dispatch } from 'react';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import Loading from '../loading/loading';
import { IForumPostProps } from '../../models/components/forum-post';
import { getForumMessage, sendForumMessageByThreadId, answerMessageGetAction, ratingMessage, updateForumMessageStatus } from '../../store/actions/forum';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Common } from '../../core/common';
import Moment from 'moment';
import { SecureImage } from '../core/secureImage';
import MessageProccessing from './messageProcess';
import { ForumMessageStatus } from '../../models/enums/forumMessageStatus';
import Quil from '../input/quil/main';
import { FileUpload } from '../../components/file-upload/main';
import { Guid } from 'guid-typescript';
import { Notification } from '../notification/main';
import Rating from 'react-rating';
import { IMessageRating } from '../../models/components/forum-message';
import { ChatEmojiPicker } from '../../pages/messages/chatEmojiPicker';
import ContentLoader from 'react-content-loader';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import { EModuleType } from '../../models/components/input-quil.d';
import { UserType } from '../../models/enums/userType';
import { ForumThreadType } from '../../models/enums/forumThreadType';

const _logger = Log.create('forumPost.tsx');
const T = Translator.create();
const _common: Common = new Common();
class ForumPost extends React.Component<IForumPostProps, any> {
    chatEmojiPicker: any;
    quillRef: Quil | null = null;
    quillRef_quotedMessage: Quil | null = null;
    private messagesEndRef: React.RefObject<HTMLDivElement>;

    constructor(props: any) {
        super(props);
        this.messagesEndRef = React.createRef();

        this.state = {
            textAreaValue: '',
            commentBoxValue: '',
            searchedWord: '',
            fileUploadKey: 'message_upload_' + this.props.identity.userId + '_' + Guid.create(),
            showFileUploaderCount: 0,
            fileUploaded: false,
            quotingValue: '',
            showEmojiPicker: false,
            _guidKey: Guid.create().toString(),
            forumMessagesIsAll: false,
            isLoading: false,
            getQuillToolbarModule: this.getQuillToolbarModule(),
            isLoadingProcess: false,
            isMessageSent: false,
            answersVisible: false,
            hasModerator: false,
        };
        this.sendMessageCallback = this.sendMessageCallback.bind(this);
    }

    public onScrollDetected = (event: any) => {
        const element = event.target;
        if (
            element.scrollHeight - (element.scrollTop + 20) <= element.clientHeight &&
            !this.state.forumMessagesIsAll &&
            !this.state.isLoading
        ) {
            this.setState({ isLoading: !this.state.isLoading });
            setTimeout(() => {
                this.props.dispatch(
                    getForumMessage(
                        this.props.forumThreadId!,
                        this.props.forumSubject!,
                        this.props.forumMessageSkip! + 10,
                        this.props.forumMessageTake!,
                        'getForumMessageLoadingBox',
                        'get',
                        null,
                        false,
                        this.getMessageListCallback
                    )
                );
            }, 200);
        }
    };

    public onKeyPressForumPost = () => {
        if(this.state.isMessageSent)
            {
                return;
            }
        this.setState({ isLoadingProcess: true, isMessageSent: true })
        if (this.state.showFileUploaderCount <= 0 && !this.state.textAreaValue) {
            Notification.setNotification('error', T.t('r_forum_message_content_not_found'), 'topRight');
            this.setState({ isLoadingProcess: false, isMessageSent: false })
        } else {
            this.props.dispatch(
                sendForumMessageByThreadId(
                    this.state.textAreaValue,
                    this.props.forumThreadId!,
                    this.props.forumSubject!,
                    '',
                    this.state.fileUploadKey,
                    this.sendMessageCallback
                )
            );
            this.resetFileUploder();
            this.setState({ textAreaValue: '', showFileUploaderCount: 0 });
            this.handleResetText();

        }
    };

    handleResetText() {
        if (this.quillRef) {
            this.quillRef.state.description = "";
        }
    }

    handleResetQuotedMessage() {
        if (this.quillRef_quotedMessage) {
            this.quillRef_quotedMessage.state.description = "";
        }
    }

    sendMessageCallback = (isAll: boolean, messageId?: string) => {
        this.setState({ isMessageSent: false });

        this.getMessageList(false, messageId);
    };

    public triggerCommentBox = (key: string, type: string) => {
        if (type === 'down') {
            $('#' + key).slideDown();
        } else {
            $('#' + key).slideUp();
            this.setState({ commentBoxValue: '' });
        }
    };

    public answerMessage = (messageId: string, searchBoxKey: string) => {
        if (this.state.commentBoxValue) {
            if (this.state.commentBoxValue.replace(/(<([^>]+)>)/gi, '').length > 3) {
                this.props.dispatch(
                    answerMessageGetAction(
                        this.state.commentBoxValue,
                        this.props.forumThreadId!,
                        messageId,
                        this.props.forumSubject!,
                        false,
                        this.answerCallback
                    )
                );
            } else {
                Notification.setNotification('error', T.t('r_validation_add_forum_message') + ' - ' + T.t('r_field_required'), 'topRight');
            }
        } else {
            Notification.setNotification('error', T.t('r_validation_add_forum_message') + ' - ' + T.t('r_field_required'), 'topRight');
        }
    };

    answerCallback = (messageId: string) => {
        this.setState({ commentBoxValue: '' });
        this.handleResetQuotedMessage();
        this.getMessageList(false, messageId);
    };

    triggerSearchBox = (type: string) => {
        if (type === 'down') {
            $('#' + 'search-box').slideDown();
        } else {
            $('#' + 'search-box').slideUp();
            this.setState({ searchedWord: '' }, () => {
                this.getMessageList();
            });
        }
    };

    getMessageList = (isAll?: boolean, messageId?: string) => {
        this.props.dispatch(
            getForumMessage(
                this.props.forumThreadId!,
                this.props.forumSubject!,
                0,
                20,
                'getForumMessage',
                'get',
                this.state.searchedWord,
                isAll,
                this.getMessageListCallback,
                messageId
            )
        );
    };

    getMessageListCallback = (messageId: string, isAll?: boolean) => {
        this.setState({ isLoading: !this.state.isLoading, isLoadingProcess: false });
        if (messageId) {
            this.goToMessage(messageId);
        } else {
            this.setState({ forumMessagesIsAll: true });
        }
    };

    goToMessage = (messageId?: string) => {
       
       const getForumContentWindow = document.getElementById('forum-content');
       if (getForumContentWindow) {
        getForumContentWindow.scrollTop = getForumContentWindow.scrollHeight;
       }

          if(messageId)
          {

          const answerBlock = document.getElementById('ForumAnswer-' + messageId);

          if (answerBlock) {
              answerBlock.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
              });
          }
        }
      
    };

    searchOnChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ searchedWord: event.target.value });

    searchOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === 13) {
            this.getMessageList();
        }
    };

    handleFileModalClose = (uppy: any) => {
        this.props.closeFileUploader!(uppy, 'Add');
    };

    handleFileUploaded = (uppy: any) => {
        this.props.fileUploadedHandler!(uppy, 'Add');
        this.fileUploadedHandler(uppy);
    };

    resetFileUploder = () => {
        this.props.resetFileUploader!();
        this.setState({ fileUploadKey: 'message_upload_' + this.props.identity.userId + '_' + Guid.create(), fileUploaded: false });
    };

    fileUploadedHandler = (uppy: any) => {
        this.setState({
            fileUploaded: true,
            showFileUploaderCount: Object.keys(uppy.store.state.files).length
        });
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    componentDidUpdate(prevProps: any, prevState: any) {
        const searchParams = new URLSearchParams(window.location.search);
        const hasModerator = searchParams.get('hasModerator') === 'true';
        const nodeEnter = document.getElementsByClassName("ql-editor ql-blank")[0];

        if (prevState.hasModerator !== hasModerator) {
            this.setState({ hasModerator });
        }

        if (nodeEnter) {

            nodeEnter.addEventListener("keyup", (event: any) => {
                if (event.key === "Enter" && !event.shiftKey) {
                    this.onKeyPressForumPost()
                }
            });
        }
        if (prevProps.forumMessages !== this.props.forumMessages) {
            this.goToMessage();
            this.setState({ _guidKey: Guid.create().toString(), forumMessagesIsAll: false });
        }
        if (prevProps.forumThreadId !== this.props.forumThreadId) {
            this.setState({ textAreaValue: '' });
        }
    }

    calculateRating = (ratings: IMessageRating[]) => {
        let rating: number = 0;
        let totalRating: number = 0;
        if (ratings && ratings.length) {
            if (ratings.length === 1) {
                return ratings[0].rating;
            }
            rating = ratings.length * 5;

            ratings.forEach((rate: IMessageRating) => {
                totalRating = totalRating + rate.rating;
            });
            rating = parseFloat((((totalRating * 100) / rating / 100) * 5).toFixed(1));
            return rating;
        }

        return 0;
    };

    ratePost = (value: any, messageId: string) => {
        this.props.dispatch(
            ratingMessage({ messageId, threadId: this.props.forumThreadId!, rating: value }, '', 'get', this.getMessageList)
        );
    };

    quotingPost = (message: string, fullName: string, updatedDate: Date) => {
        if (message) {
            let quotingValue =
                "<blockquote><i>'" + T.t("r_forum_message_says", { 0: fullName });
            quotingValue +=
                message +
                "<br>" +
                Moment(updatedDate).format(
                    _common.GetDateFormatFromPrefrences(this.props.userPreferences, 2)
                ) +
                "'</i></blockquote>";
            this.setState((prevState: any) => ({
                quotingValue: quotingValue,
                textAreaValue: prevState.textAreaValue + quotingValue + "<p>-</p>",
            }));
        }
    };


    messageOnChange = (event: any) => {
        if (event !== this.state.textAreaValue) {
            this.setState({ textAreaValue: event });
        }
    };

    toggleEmojiPicker = () => {
        this.setState({
            showEmojiPicker: !this.state.showEmojiPicker
        });
    };

    addEmoji = (emoji: any) => {
        this.setState({
            textAreaValue: this.state.textAreaValue + emoji.native,
            showEmojiPicker: false
        });
    };

    getQuillToolbarModule = () => {
        return (window.innerWidth > 760) ? EModuleType.basic : EModuleType.mobile
    };

    renderMessageProcessing = (data: any) => {
        if (this.props.identity.userId === data.senderId) {
            return <MessageProccessing
                threadId={this.props.forumThreadId!}
                modalTrigger={this.props.openCommentModal}
                updateMessageId={data.forumMessageId}
            />
        }

    }

    renderForumMessageFiles = (data: any) => {
        return (
            <div className="row">
                <div className="upload-files-name pl-3 pr-3">
                    {data.files.map((file: any, fileIndex: any) => (
                        <button
                            key={fileIndex}
                            type="button"
                            className="file-name mr-3 mb-3 float-left"
                            onClick={this.clickToDownload}
                            data-filepath={file && file.path}
                            data-filename={file && file.fileName}
                            style={{
                                display: 'flex',
                                border: '1px solid rgb(238, 238, 238)',
                                boxShadow: 'rgba(0, 0, 0, 0.2) 3px 3px 5px 1px'
                            }}
                        >
                            <i
                                className="mr-1 material-icons"
                                style={{ verticalAlign: 'middle' }}
                            >
                                attach_file
                            </i>
                            {file.fileName}
                            <span
                                className="ml-2 mb-0"
                                style={{ verticalAlign: 'inherit', marginTop: '1px' }}
                            >
                                {_common.BytesToSize(file ? parseInt(file.size, 10) : 0)}
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        )
    }

    renderForumMessageRating = (data: any) => {
        return (
            <div className="revote pl-4 pr-4 pb-1">
                <div className="stars">
                    <Rating
                        readonly={data.senderId === this.props.identity.userId}
                        fractions={2}
                        className={'float-forum'}
                        direction={document.body.getAttribute('dir') == 'ltr' ? 'ltr' : 'rtl'}
                        placeholderRating={
                            data.ratings.filter((f: any) => f.userId === this.props.identity.userId)
                                .length > 0
                                ? data.ratings.filter(
                                    (f: any) => f.userId === this.props.identity.userId
                                )[0].rating
                                : 0
                        }
                        emptySymbol={
                            <i
                                className="material-icons mr-0 star_yellow"
                                style={{ padding: '3px' }}
                            >
                                star_border
                            </i>
                        }
                        placeholderSymbol={
                            <i
                                className="material-icons mr-0 star_yellow"
                                style={{ padding: '3px' }}
                            >
                                star
                            </i>
                        }
                        fullSymbol={
                            <i
                                className="material-icons mr-0 star_yellow"
                                style={{ padding: '3px' }}
                            >
                                star
                            </i>
                        }
                        // tslint:disable-next-line
                        onClick={(value: any) =>
                            data.senderId !== this.props.identity.userId &&
                            this.ratePost(value, data.forumMessageId)
                        }
                    />
                    {data.ratings.length > 0 && (
                        <span className="float-forum mt-1 forum-star">
                            {this.calculateRating(data.ratings)}
                        </span>
                    )}
                    <label className="float-forum mt-1 forum-star">
                        {data.ratings.length > 0 ? (
                            <>&nbsp;{T.t('r_forum_vote_count', { 0: data.ratings.length })}</>
                        ) : (
                            <>&nbsp;{T.t('r_forum_no_votes')}</>
                        )}
                    </label>
                </div>
            </div>
        )
    }

    renderForumMessageQuating = (data: any, index: any) => {
        return (
            <div className="option" style={{ paddingBottom: "20px", paddingInlineEnd: "20px", paddingInlineStart: "5px", float: "inline-start" }} >
                <a onClick={this.triggerCommentBox.bind(this, 'CommentBox-' + index, 'down')} className='answer-button' >
                    {T.t('r_forum_write_answer')}
                </a>
                <a
                    onClick={this.quotingPost.bind(
                        this,
                        data.message,
                        data.fullName,
                        data.lastUpdatedDate
                    )}
                    className='quote-button'
                >
                    {T.t('r_forum_quoting')}
                </a>
            </div>
        )
    }

    renderCommentBox = (data: any, index: any) => {
        return (
            <><div className="clear" /><div
                id={'CommentBox-' + index}
                style={{ padding: '0px 20px 20px 20px', zIndex: 10, display: 'none' }}
                className={'comments'}
            >
                <Quil
                    ref={ref => { this.quillRef_quotedMessage = ref; }}
                    modules={this.getQuillToolbarModule()}
                    placeholder={T.t('r_forum_comment_box_place_holder').replace(
                        '{0}',
                        this.props.identity.fullName
                    )}
                    // tslint:disable-next-line
                    onChange={(e: any) => {
                        this.setState({ commentBoxValue: e });
                    }}
                    className={'custom-quill'}
                    value={this.state.commentBoxValue ? this.state.commentBoxValue : ''}
                    theme={'snow'} />
                <div className="option mt-3">
                    <a
                        onClick={this.answerMessage.bind(
                            this,
                            data.forumMessageId,
                            'CommentBox-' + index
                        )}
                        className="btn"
                    >
                        <i className="material-icons float-left mr-2 mt-1">send</i>
                        <div className="float-right">{T.t('r_gen_send_answer')}</div>
                    </a>
                </div>

                <div className="option mt-3">
                    <a
                        onClick={this.triggerCommentBox.bind(this, 'CommentBox-' + index, 'up')}
                        id="close"
                        className="btn"
                    >
                        <i className="material-icons mr-2 mt-1">close</i>
                        <div className="float-right">{T.t('r_cancel_button')}</div>
                    </a>
                </div>

                <div className="clear" />
            </div></>
        )
    }

    renderForumMessageAnswers = (data: any) => {
        return (
            <>
                <div className="options">
                    <h5>{T.t('r_gen_answer_count').replace('{0}', data.answerCount)}</h5>
                </div>

                {data.answerCount > 0 && (
                    <div className={'comments'}>
                        <div className="text pl-5 pr-4 pb-0" style={{ marginTop: '-11px' }}>
                            {data.answerCount > 0 && data.answers && data.answers.length > 0
                                ? data.answers.map((answer: any, answerIndex: any) => (
                                    <div
                                        key={answerIndex}
                                        id={'ForumAnswer-' + answer.forumMessageId}
                                        className="sub-text pt-4"
                                    >
                                        {this.props.identity.userId === answer.senderId &&
                                            answer.messageStatus !==
                                            ForumMessageStatus.Deleted && (
                                                <MessageProccessing
                                                    threadId={this.props.forumThreadId!}
                                                    modalTrigger={this.props.openCommentModal}
                                                    updateMessageId={answer.forumMessageId}
                                                />
                                            )}

                                        {answer.messageStatus ===
                                            ForumMessageStatus.Deleted ? (
                                            <>
                                                <SecureImage
                                                    style={{
                                                        width: '24px',
                                                        borderRadius: 100
                                                    }}
                                                    class={'userProfile mr-2 float-forum'}
                                                    imageUrl={answer.avatar}
                                                />
                                                <p>
                                                    <i>
                                                        {T.t('r_forum_deleted_by', {
                                                            0: answer.fullName,
                                                            1: Moment(
                                                                answer.lastUpdatedDate
                                                            ).fromNow()
                                                        })}
                                                    </i>
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <p>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: answer.message
                                                        }}
                                                    />
                                                </p>
                                                <div className="desc pt-0 pb-0">
                                                    <SecureImage
                                                        style={{
                                                            width: '24px',
                                                            borderRadius: 100
                                                        }}
                                                        class={'userProfile mr-2 float-forum'}
                                                        imageUrl={answer.avatar}
                                                    />
                                                    <span className="mb-0">
                                                        {answer.fullName + ' '}
                                                        {T.t('r_gen_by') + ' '}
                                                        {answer.createdDate !==
                                                            answer.lastUpdatedDate
                                                            ? T.t('r_gen_updated_on').replace(
                                                                '{0}',
                                                                Moment(
                                                                    answer.lastUpdatedDate
                                                                ).fromNow()
                                                            )
                                                            : Moment(
                                                                answer.createdDate
                                                            ).fromNow()}
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ))
                                : ''}
                        </div>
                        <hr />
                    </div>
                )}
            </>
        )
    }

    renderUserForumMessage = (data: any) => {
        return (
            <div className="desc" style={{ padding: '20px 20px 0px 20px' }}>
                <SecureImage
                    style={{ width: '36px', borderRadius: 100 }}
                    class={'userProfile mr-2'}
                    imageUrl={data.avatar}
                    key={this.state._guidKey}
                />
                <span>{data.fullName}</span>{' '}
                <span className="ml-2">
                    {data.createdDate !== data.lastUpdatedDate &&
                        data.lastUpdatedDate > data.createdDate
                        ? T.t('r_gen_updated_on').replace(
                            '{0}',
                            Moment(data.lastUpdatedDate).fromNow()
                        )
                        : Moment(data.createdDate).fromNow()}
                </span>
                {this.renderMessageProcessing(data)}
            </div>
        )
    }

    messageOnChangeStatus = (messageData: any, type: any) => {
        this.props.dispatch(updateForumMessageStatus(messageData, type == "approve", 'updateForumMessageStatus', 'get', this.getMessageList));
    }

    renderModeratorCheck = (data: any, index: number) => {
        const renderMessageContent = () => (
            <>
                {this.renderUserForumMessage(data)}
                <div className="text" style={{ padding: '20px 20px 0px 20px' }}>
                    {data.message && (
                        <div>
                            <p
                                className="break-word"
                                style={{ textAlign: 'justify' }}
                                dangerouslySetInnerHTML={{ __html: data.message }}
                            />
                        </div>
                    )}
                    {this.renderForumMessageFiles(data)}
                </div>
            </>
        );

        const renderActions = (entityType: ForumThreadType) => {
            
            const canModerate =this.props.userType === UserType.Admin ||(entityType === ForumThreadType.Activity && this.props.userType !== UserType.Student);

            return (
                <div className="d-flex justify-content-between">
                    <div>
                        {this.renderForumMessageQuating(data, index)}
                        {this.renderForumMessageRating(data)}
                    </div>
                    {canModerate ? (
                        <div>
                            <button
                                type="button"
                                className="category-tag-square tag-green ml-2 mr-2"
                                onClick={() => this.messageOnChangeStatus(data, 'approve')}
                            >
                                <i className="material-icons mx-1">done</i>
                                {T.t('r_accept')}
                            </button>
                            <button
                                type="button"
                                className="category-tag-square tag-red ml-2 mr-2"
                                onClick={() => this.messageOnChangeStatus(data, 'reject')}
                            >
                                <i className="material-icons mx-1">close</i>
                                {T.t('r_reject')}
                            </button>
                        </div>
                    ) : (
                        <p>{T.t('r_pending')}</p>
                    )}
                </div>
            );
        };

        const renderCommentAndAnswers = () => (
            <>
                {this.renderCommentBox(data, index)}
                {data.answerCount > 0 && this.renderForumMessageAnswers(data)}
            </>
        );

        if (!this.state.hasModerator) {
            return (
                <div
                    key={`ForumMessage-${data.forumMessageId}`}
                    id={`ForumMessage-${data.forumMessageId}`}
                    style={{ height: 'auto' }}
                >
                    <div style={{ zIndex: 20 }}>
                        {renderMessageContent()}
                        <div className="d-flex justify-content-between">
                            <div>
                                {this.renderForumMessageQuating(data, index)}
                                {this.renderForumMessageRating(data)}
                            </div>
                        </div>
                    </div>
                    {renderCommentAndAnswers()}
                </div>
            );
        }

        const entityType = this.props.forumConversation?.find(x => x.forumThreadId === this.props.forumThreadId)?.entityType;

        switch (data.messageStatus) {
            case ForumMessageStatus.Approved:
                return (
                    <div
                        key={`ForumMessage-${data.forumMessageId}`}
                        id={`ForumMessage-${data.forumMessageId}`}
                        style={{ height: 'auto' }}
                    >
                        <div style={{ zIndex: 20 }}>
                            {renderMessageContent()}
                            <div className="d-flex justify-content-between">
                                <div>
                                    {this.renderForumMessageQuating(data, index)}
                                    {this.renderForumMessageRating(data)}
                                </div>
                                {this.state.hasModerator && (
                                    <span className="mr-2 ml-2">{T.t('r_approved')}</span>
                                )}
                            </div>
                        </div>
                        {renderCommentAndAnswers()}
                    </div>
                );

            case ForumMessageStatus.Pending:
                return (
                    <div
                        key={`ForumMessage-${data.forumMessageId}`}
                        id={`ForumMessage-${data.forumMessageId}`}
                        style={{ height: 'auto' }}
                        className="message-status-box pending"
                    >
                        <div style={{ zIndex: 20 }}>
                            {renderMessageContent()}
                            {renderActions(entityType ?? ForumThreadType.Organization)}
                        </div>
                        {renderCommentAndAnswers()}
                    </div>
                );

            case ForumMessageStatus.Rejected:
                return (
                    <div
                        key={`ForumMessage-${data.forumMessageId}`}
                        id={`ForumMessage-${data.forumMessageId}`}
                        style={{ height: 'auto' }}
                        className="message-status-box"
                    >
                        <div style={{ zIndex: 20 }}>
                            {renderMessageContent()}
                            <div className="d-flex justify-content-between">
                                <div>
                                    {this.renderForumMessageQuating(data, index)}
                                    {this.renderForumMessageRating(data)}
                                </div>
                                <span className="mr-2 ml-2">{T.t('r_rejected')}</span>
                            </div>
                        </div>
                        {renderCommentAndAnswers()}
                    </div>
                );

            default:
                return null;
        }
    };

    renderForumContent = () => {
        return (
            <div
                className="forum-content p-2"
                onScroll={this.onScrollDetected}
                id="forum-content"
                style={{ overflowX: 'hidden' }}
                ref={this.messagesEndRef}
            >
                {this.props.forumMessages && this.props.forumMessages.length > 0 ? (
                    this.props.forumMessages.map((data, index) => {
                        return (
                            this.renderModeratorCheck(data, index)
                        );
                    })
                ) : (


                    <h6 className='no-messages-text'>
                        <span>{T.t('r_no_messages_found')}</span>
                    </h6>

                )}


            </div>
        )
    }

    renderLoading = () => {
        const loadingSpaces = 483;
        return (
            <Loading spinnerId={'getForumMessage'} height={'calc(100vh - 197px)'}>
                <div style={{ backgroundColor: '#fbfaf6', height: '100%' }}>
                    <ContentLoader
                        speed={2}
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                        style={{ width: '100%', height: '100%' }}
                        preserveAspectRatio="xMinYMin meet"
                    >
                        <rect x="22" y="24" rx="3" ry="3" width="60%" height="13" />
                        <rect x="0" y="57" rx="3" ry="3" width="100%" height="2" />
                        <circle cx="44" cy="100" r="22" />
                        <rect x="74" y="94" rx="3" ry="3" width="40%" height="12" />
                        <rect x="24" y="140" rx="3" ry="3" width="96.6%" height="10" />
                        <rect x="24" y="160" rx="3" ry="3" width="96.6%" height="10" />
                        <rect x="24" y="180" rx="3" ry="3" width="96.6%" height="10" />
                        <rect x="24" y="200" rx="3" ry="3" width="80%" height="10" />
                        <rect x="24" y="230" rx="5" ry="5" width="20" height="21" />
                        <rect x="56" y="230" rx="5" ry="5" width="20" height="21" />
                        <rect x="88" y="230" rx="5" ry="5" width="20" height="21" />
                        <rect x="120" y="230" rx="5" ry="5" width="20" height="21" />
                        <rect x="152" y="230" rx="5" ry="5" width="20" height="21" />
                        <rect x="190" y="235" rx="3" ry="3" width="25%" height="11" />

                        <rect x="94%" y="235" rx="3" ry="3" width="50" height="10" />
                        <rect x="89%" y="235" rx="3" ry="3" width="50" height="10" />

                        <rect x="0" y="270" rx="3" ry="3" width="100%" height="2" />
                        <rect x="24" y="290" rx="3" ry="3" width="15%" height="13" />
                        <rect x="0" y="320" rx="3" ry="3" width="100%" height="2" />
                        <rect x="54" y="340" rx="3" ry="3" width="94%" height="10" />
                        <rect x="54" y="360" rx="3" ry="3" width="60%" height="10" />
                        <circle cx="68" cy="400" r="15" />
                        <rect x="94" y="395" rx="3" ry="3" width="30%" height="12" />
                        <rect x="54" y="430" rx="3" ry="3" width="100%" height="2" />
                        <rect x="54" y="450" rx="3" ry="3" width="94%" height="10" />
                        <rect x="54" y="470" rx="3" ry="3" width="60%" height="10" />
                        <circle cx="68" cy="510" r="15" />
                        <rect x="94" y="505" rx="3" ry="3" width="30%" height="12" />
                        <rect x="0" y="540" rx="3" ry="3" width="1320" height="2" />

                        <circle cx="44" cy={100 + loadingSpaces} r="22" />
                        <rect x="74" y={94 + loadingSpaces} rx="3" ry="3" width="400" height="12" />
                        <rect x="24" y={140 + loadingSpaces} rx="3" ry="3" width="1275" height="10" />
                        <rect x="24" y={160 + loadingSpaces} rx="3" ry="3" width="1275" height="10" />
                        <rect x="24" y={180 + loadingSpaces} rx="3" ry="3" width="1275" height="10" />
                        <rect x="24" y={200 + loadingSpaces} rx="3" ry="3" width="1000" height="10" />

                        <rect x="24" y={230 + loadingSpaces} rx="5" ry="5" width="20" height="21" />
                        <rect x="56" y={230 + loadingSpaces} rx="5" ry="5" width="20" height="21" />
                        <rect x="88" y={230 + loadingSpaces} rx="5" ry="5" width="20" height="21" />
                        <rect x="120" y={230 + loadingSpaces} rx="5" ry="5" width="20" height="21" />
                        <rect x="152" y={230 + loadingSpaces} rx="5" ry="5" width="20" height="21" />
                        <rect x="190" y={235 + loadingSpaces} rx="3" ry="3" width="300" height="11" />

                        <rect x="94%" y={235 + loadingSpaces} rx="3" ry="3" width="50" height="10" />
                        <rect x="89%" y={235 + loadingSpaces} rx="3" ry="3" width="50" height="10" />
                    </ContentLoader>
                </div>
            </Loading>
        )
    }

    isForumEmpty = () => {
        let content;

        if (this.props.forumMessages && this.props.forumConversation && this.props.forumMessages.length > 0 && this.props.forumConversation.length > 0) {
            content = this.renderLoading();
        } else if (this.props.forumConversation && this.props.forumConversation!.length > 0) {
            content = <Loading spinnerId={'getForumMessage'} height={'calc(100vh - 197px)'} />
        } else if (!this.props.forumConversation || this.props.forumConversation.length === 0) {
            content = <div className="forum-empty d-flex flex-column justify-content-center align-items-center" >
                <img src={_common.DefaultLogos.message} className="forum-mask" alt='forumEmptyImg' />
                <h5 className="forum-non-added">{T.t('r_no_argument_here_yet')}</h5>
                <h5 className="forum-information">{T.t('r_survey_replay_found')}</h5>
            </div>;
        }
        return content;
    }

    render() {
        let content = this.isForumEmpty();

        return (
            <div className="custom-col-forum-2">
                <div id="getFormMessage_Window" className="conversation-window" style={{ overflow: 'hidden' }}>
                    {content}
                    {this.props.forumConversation && this.props.forumConversation.length > 0 ? (
                        <div className="forum-content-get" id="getForumMessage_Content">
                            <div
                                style={{ position: 'relative' }}
                                className="conversation-header conversation-header-forum d-flex align-items-center justify-content-between relative"
                            >
                                <button
                                    onClick={() => {
                                        const getAllActiveClass = document.getElementsByClassName('mobile_chat_form_panel');
                                        const elementsArray = Array.from(getAllActiveClass);

                                        for (const element of elementsArray) {
                                            element.classList.remove('mobile_chat_form_panel');
                                        }
                                    }}
                                    id="backToFormList"
                                    className="display_m_flex"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    style={{ background: 'none', border: 'none' }}
                                >
                                    <i className="material-icons">chevron_left</i>
                                </button>

                                <div className={"userinfo media align-items-center" + (!_common.isArabic(this.props.forumSubject, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} style={{ fontWeight: 'bold' }}>
                                    {this.props.forumSubject}
                                </div>

                                <div className="dropdown d-flex align-items-center">
                                    <button
                                        style={{ border: 'none', background: 'none' }}
                                        data-toggle="collapse"
                                        aria-expanded="true"
                                        className="search-link"
                                        onClick={this.triggerSearchBox.bind(this, 'down')}
                                    >
                                        <i className="material-icons mr-2" style={{ fontSize: '20px' }}>
                                            search
                                        </i>
                                        {T.t('r_gen_search')}
                                    </button>
                                    <a className="d-flex justify-content-between align-items-center">
                                        <i className="material-icons">more_horiz</i>
                                    </a>
                                </div>

                                <div className="search-bar" id="search-box">
                                    <div className="d-flex align-items-center">
                                        <i className="material-icons">search</i>
                                        <input
                                            type="text"
                                            className="mt-2"
                                            id="forum-search"
                                            placeholder={T.t('r_gen_search')}
                                            value={this.state.searchedWord}
                                            onChange={this.searchOnChange}
                                            onKeyUp={this.searchOnKeyUp}
                                        />
                                        <button style={{ border: 'none', background: 'none' }} onClick={this.triggerSearchBox.bind(this, 'up')} className="close" id="closed">
                                            <i className="material-icons">close</i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {this.renderForumContent()}

                        </div>
                    ) : (
                        <div className="forum-empty d-flex flex-column justify-content-center align-items-center " >
                            <img src={_common.DefaultLogos.message} className="forum-mask" alt='forumEmpty' />
                            <h5 className="forum-non-added">{T.t('r_no_argument_here_yet')}</h5>
                            <h5 className="forum-information">{T.t('r_survey_replay_found')}</h5>
                        </div>
                    )}
                    {this.props.forumConversation && this.props.forumConversation.length > 0 &&
                        <div className="type-message-field" style={{ padding: '5px 0' }}>

                            <div className="input-group d-block" style={{ padding: '0px' }}>
                                <Quil
                                    ref={ref => { this.quillRef = ref }}
                                    modules={this.getQuillToolbarModule()}
                                    placeholder={T.t('r_forum_postmessage')}
                                    // tslint:disable-next-line
                                    onChange={this.messageOnChange}
                                    className={'custom-quill-message'}
                                    value={this.state.textAreaValue}
                                    theme={'snow'}
                                />
                                <div className="input-group-append">
                                    {this.state.getQuillToolbarModule !== EModuleType.mobile && (
                                        <div>
                                            {
                                                this.state.showEmojiPicker ? (
                                                    <ChatEmojiPicker
                                                        customStyle={{ bottom: 128 + 'px' }}
                                                        showEmojiPicker={this.state.showEmojiPicker}
                                                        onSelect={this.addEmoji}
                                                        handleClickOutside={this.toggleEmojiPicker}
                                                        ref={e => (this.chatEmojiPicker = e)}
                                                        locale={T.i18next.language}
                                                    />
                                                ) : null
                                            }
                                            < div className="r-d-flex">
                                                <a className="input-group-text" onClick={this.toggleEmojiPicker}>
                                                    <i className="material-icons">tag_faces</i>
                                                </a>
                                                <a className="input-group-text">
                                                    <i className="material-icons" onClick={this.props.showFileUploader!.bind(this, 'Add')}>
                                                        add
                                                    </i>
                                                </a>
                                            </div>
                                            {this.state.fileUploaded ? (
                                                <div style={{ position: 'absolute', right: '105px', bottom: '43px' }}>
                                                    <span
                                                        style={{ height: '16px', color: 'orange', marginLeft: '-10px' }}
                                                        className="badge badge-pill badge-light"
                                                    >
                                                        {this.state.showFileUploaderCount}
                                                    </span>
                                                    <span
                                                        style={{ height: '16px', color: 'red', marginLeft: '0px', cursor: 'pointer' }}
                                                        title="Dosyayı sil"
                                                        className="badge badge-pill badge-light"
                                                        onClick={this.resetFileUploder}
                                                    >
                                                        x
                                                    </span>
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                    {this.props.forumThreadId && (
                                        <a onClick={this.onKeyPressForumPost} className="input-group-text">
                                            <i style={{ marginRight: '5px' }} className="material-icons">
                                                send
                                            </i>
                                            <div>
                                                {this.state.isLoadingProcess ? T.t('r_gen_sending') : T.t('r_send')}
                                            </div>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {
                    this.props.showFileUploaderState ? (
                        <FileUpload
                            key={this.state.fileUploadKey}
                            fileInputKey={this.state.fileUploadKey}
                            height={250}
                            maxFileSize={10000000}
                            maxSelectedFileCount={5}
                            isCardImage={false}
                            isModal={true}
                            modalOpen={this.props.showFileUploaderState}
                            handleModalClose={this.handleFileModalClose}
                            triggerFileUpload={this.handleFileUploaded}
                            fileTypes={window.appSettings.ForumFileUploadAllowedTypes}
                            activityType={ActivityTypeEnums.Forum}
                        />
                    ) : (
                        ''
                    )
                }
            </div >
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IForumPostProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IForumPostProps = Object.assign({}, ownProps, {
        forumConversation: state.forum.forumConversation,
        culture: state.login.identitiy.culture,
        forumMessages: state.forum.forumMessages,
        forumMessageTake: state.forum.forumMessageTake,
        forumMessageSkip: state.forum.forumMessageSkip,
        forumSubject: state.forum.forumMessageSubject,
        forumThreadId: state.forum.forumMessageThreadId,
        identity: state.login.identitiy,
        userPreferences: state.profile.userPreferences.preferences,
        isSimulate: state.login.identitiy.isSimulate,
        userType: state.login.identitiy.userType
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return false;
};

const CForumPost = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(ForumPost);

export default CForumPost;
